import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "field" };
const _hoisted_2 = { class: "field" };
const _hoisted_3 = { for: "country" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("var", { class: "required" }, "*", -1);
const _hoisted_5 = ["value"];
const _hoisted_6 = { class: "field" };
const _hoisted_7 = { class: "field" };
const _hoisted_8 = { class: "field" };
const _hoisted_9 = { class: "field" };
const _hoisted_10 = { class: "field" };
const _hoisted_11 = { class: "field" };
const _hoisted_12 = { class: "field" };
const _hoisted_13 = { class: "field" };
import { ref, onMounted, computed } from "vue";
import { __ } from '../../js/helpers/i18n';
import Input from "../Form/Input.vue";
import { customSelect } from '../../js/functions/custom-forms';
export default /*#__PURE__*/ _defineComponent({
    props: {
        old: {
            type: Object,
            default: {},
        },
        countries: {
            type: Object,
            default: {}
        }
    },
    setup(__props, { expose }) {
        const props = __props;
        const old = ref(props.old);
        const countries = ref(props.countries);
        const selectedCountry = ref(old.value.country || 'PL');
        let formFields = {};
        const postCodeRegex = computed(() => selectedCountry.value === 'PL' ? /^[0-9]{2}-[0-9]{3}/ : '');
        expose({
            formFields
        });
        onMounted(() => {
            customSelect();
        });
        const setRef = (e) => {
            if (e)
                formFields[e.name] = e;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(Input, {
                        ref: setRef,
                        value: old.value.name,
                        labelText: _unref(__)('Nazwa Firmy'),
                        name: "company[name]",
                        required: "",
                        min: 2
                    }, null, 8, ["value", "labelText"])
                ]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("label", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_unref(__)("Państwo")) + " ", 1),
                        _hoisted_4
                    ]),
                    _withDirectives(_createElementVNode("select", {
                        id: "company_country",
                        name: "company[country]",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedCountry).value = $event))
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (display, value) => {
                            return (_openBlock(), _createElementBlock("option", { value: value }, _toDisplayString(display), 9, _hoisted_5));
                        }), 256))
                    ], 512), [
                        [_vModelSelect, selectedCountry.value]
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createVNode(Input, {
                        ref: setRef,
                        value: old.value.tax_no,
                        labelText: _unref(__)('NIP'),
                        name: "company[tax_no]",
                        required: "",
                        validType: "nip"
                    }, null, 8, ["value", "labelText"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createVNode(Input, {
                        ref: setRef,
                        value: old.value.street,
                        labelText: _unref(__)('Ulica'),
                        name: "company[street]",
                        required: "",
                        "dash-only": ""
                    }, null, 8, ["value", "labelText"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(Input, {
                        ref: setRef,
                        value: old.value.house_no,
                        labelText: _unref(__)('Nr domu'),
                        name: "company[house_no]",
                        required: ""
                    }, null, 8, ["value", "labelText"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(Input, {
                        ref: setRef,
                        value: old.value.flat_no,
                        labelText: _unref(__)('Nr mieszkania'),
                        name: "company[flat_no]",
                        validType: "flat_number"
                    }, null, 8, ["value", "labelText"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createVNode(Input, {
                        ref: setRef,
                        value: old.value.city,
                        labelText: _unref(__)('Miejscowość'),
                        name: "company[city]",
                        required: "",
                        min: 3,
                        max: 50,
                        "letters-only": ""
                    }, null, 8, ["value", "labelText"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createVNode(Input, {
                        ref: setRef,
                        value: old.value.zip_code,
                        labelText: _unref(__)('Kod pocztowy'),
                        name: "company[zip_code]",
                        required: "",
                        validType: "post_code",
                        postCodeRegex: _unref(postCodeRegex),
                        postCodeExample: _unref(postCodeRegex) ? '22-672' : '',
                        postCodeRequired: true,
                        "selected-country": selectedCountry.value
                    }, null, 8, ["value", "labelText", "postCodeRegex", "postCodeExample", "selected-country"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    _createVNode(Input, {
                        ref: setRef,
                        value: old.value.email,
                        labelText: _unref(__)('E-mail firmowy'),
                        name: "company[email]",
                        validType: "email",
                        required: ""
                    }, null, 8, ["value", "labelText"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _createVNode(Input, {
                        ref: setRef,
                        value: old.value.phone,
                        labelText: _unref(__)('Telefon'),
                        name: "company[phone]",
                        validType: "phone",
                        "selected-country": selectedCountry.value
                    }, null, 8, ["value", "labelText", "selected-country"])
                ])
            ], 64));
        };
    }
});
